import { formatPrice, processingFee, paypalFee } from 'Constants/payment'

export const getServiceFees = (budget, serviceFee) => (budget * serviceFee) / 100

export const getTax = (budget, serviceFee) => formatPrice(((budget + getServiceFees(budget, serviceFee) + processingFee) * paypalFee) / 0.971)

export const getTotal = (budget, serviceFee) => formatPrice((budget + getServiceFees(budget, serviceFee) + processingFee) / 0.971)